<ui-list-view
    [listItems]="(listItems$ | async) ?? fallbackListItems"
    [itemContentComponentType]="itemContentComponentType"
    [areFiltersExpanded]="areFiltersExpanded"
    (reloadListData)="reloadListData()"
>
    <ui-blue-city-filters
        filters
        (toggledFilters)="areFiltersExpanded = $event"
    />
</ui-list-view>
